
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressDocumentsEditor.html?raw';
import {
    DocumentsFileList,
    DocumentsEditorForm
} from "../../../_loadingHelpers/Address";
import _TabEnabledMixin from '../../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import { AddressWizardTypes as Types, AddressClassnames } from "../../AddressWizardTypes";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";
import { AddressTypes } from "../../../_loadingHelpers/Address";
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";

enum DocumentClassNames {
    passport = "passport",
    train_bonus_card = "train_bonus_card",
    frequent_flier_card = "frequent_flier_card",
    visa = "visa"
}

class AddressDocumentsEditor extends compose(_TabEnabledMixin, _StatefulSection) {
    templateString: any = template;

    private formContainer: HTMLElement;

    private documentsForm: MdsLax<InstanceType<typeof DocumentsEditorForm>>;   

    private expanderFilelist: MdsLax<InstanceType<typeof ExpandableSection>>;
    private documentsFileList: MdsLax<InstanceType<typeof DocumentsFileList>>;
    private editedFiles: EntityStoreData<VAM2types.FileUploadWithCategories> = null;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private entity: Types.AddressEntity;
    private className: string;
    private addressId: string;

    isValid(): boolean {

        if (!this.documentsForm.isValid()) return false;       

        return true;
    }
    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        //this.prepareFileList();
    }

    private _onChange_Files() {
        let filesData = this.documentsFileList.getData();

        this.setAttributeValue("filesData", filesData, true);

        if (filesData?.new?.length || filesData?.changed?.length || filesData?.deleted?.length) {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        }
    }

    externalEventHandler(event: "ok" ) {

        switch (event) {
            case "ok":
                this._onClicked_OK();
                break;
            default:
                this._showErrorMessage(`Wrong external event! **${event}** event not supported!`)
        }
    }
    applyAllreadyChangedData(data: AddressTypes.AddressDocumentChangeData) {

        for (let p in data.data.changedData) {
            this.setAttributeValue(p, data.data.changedData[p]);

            if (p == "filesData") {
                this.editedFiles = data.data.changedData[p];
            }
        }
    }

    prepareFileList() {

        let files = [];
        if (this.sourceData) {
            files = this.sourceData.filesData;
        }

        files?.length ? this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        
        this.documentsFileList.setup(files, this.editedFiles?.deleted, this.editedFiles?.new, this.entityId, this.className);

        this.documentsFileList.startup(); // ES GEHT MIT INHERITED EINFACH NICHT, WEISS DER KUCKUCK WARUM

        this.documentsFileList.on("change", lang.hitch(this, this._onChange_Files));
    }

    private _onClicked_OK() {

        var jsonData: AddressTypes.AddressDocumentSaveData = {
            ID: this.entityId,
            className: this.className,
            addressId: this.addressId,
            changedData: this.changedData
        }

        if (this.isValid()) {
            this.emit("okClicked", jsonData);
        } else {
            this.showToast(this.translate("General_Error_InvalidData"), "fas fa-exclamation-triangle");
        }
    }

    setClassName(className: string) {

        this.className = className;
        this.documentsForm.setClassName(className);
        this.documentsFileList.setClassName(className);

        this.documentsForm.adjustInputsForDocumentClass();
    }
    setAddressId(ID: string) {

        this.addressId = ID;
        this.documentsForm.setAddressId(ID);
    }
    setNewEntityId(ID: string) {

        this.entityId = ID;
    }

    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.resetDirty();
    }
}

export default mdsWidget(AddressDocumentsEditor);